/* tslint:disable:no-console */
export const throwOrLog = (message: string) =>
  process.env.NODE_ENV === "development"
    ? (() => {
        throw message;
      })()
    : console.error(message);
